import { QueryClient } from "@tanstack/react-query";

const queryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      retry: 2,
      retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 10000),
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      refetchOnMount: true,
      networkMode: "online" as const,
      throwOnError: false,
    },
    mutations: {
      retry: 1,
      retryDelay: 500,
      throwOnError: false,
    },
  },
};

export const queryClient = new QueryClient(queryClientConfig);
